import { render, staticRenderFns } from "./LotDetail.vue?vue&type=template&id=67d13b16&scoped=true&"
import script from "./LotDetail.vue?vue&type=script&lang=js&"
export * from "./LotDetail.vue?vue&type=script&lang=js&"
import style0 from "./LotDetail.vue?vue&type=style&index=0&id=67d13b16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d13b16",
  null
  
)

export default component.exports